<template>
  <div class="box-detail">
    <div class="box-left">
      <div class="box-left-header">
        <div
          @click="$router.push({ path: '/ServiceAgreements' })"
          class="goBack c-position-static c-m-0"
        >
          <i class="el-icon-arrow-left"></i>
          <span>服务协议</span>
          <i class="el-icon-box"></i>
        </div>
      </div>
      <div class="box-left-content">
        <c-form
          :formData="formData"
          :fields="extFields"
          :options="options"
          ref="form"
          :upload="upload"
          @changeForm="osg.changeForm"
        >
          <template slot="contactsId">
            <el-autocomplete
              popper-class="my-autocomplete"
              v-model="formData.contactsId"
              :fetch-suggestions="getContacts"
              placeholder="可输入姓名搜索"
              @select="selectContact"
              hide-loading
              value-key="name"
            >
              <template slot-scope="{ item }">
                <p class="c-flex c-flex-between">
                  <span>{{ item.name }}</span>
                  <span>{{ item.phone }}</span>
                </p>
              </template>
            </el-autocomplete>
          </template>
          <template slot="userId">
            <el-select
              v-model="formData.userId"
              filterable
              remote
              placeholder="可输入姓名搜索"
              :remote-method="getUsers"
            >
              <el-option
                v-for="item in options.users"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template slot="bizType">
            <el-select v-model="formData.bizType" @change="formData.bizId = ''">
              <el-option
                v-for="item in options.serviceAgreementBizType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template slot="bizId" v-if="formData.bizType == '1'">
            <el-select
              v-model="formData.bizId"
              filterable
              remote
              clearable
              placeholder="可输入工单标题/编号/姓名/手机号搜索"
              :remote-method="getServiceAppointments"
            >
              <el-option
                v-for="item in options.serviceAppointments"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
                <span style="float: left">{{ item.orderNum }}</span>
                <span style="float: right">{{ item.name }}:{{ item.phone }}</span>
              </el-option>
            </el-select>
          </template>
          <template slot="bizId" v-else>
            <el-select
              v-model="formData.bizId"
              filterable
              remote
              clearable
              placeholder="可输入合同编号/委托方/委托方手机号搜索"
              :remote-method="getContracts"
            >
              <el-option
                v-for="item in options.contracts"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
                <span style="float: left">{{ item.contractdocNum }}</span>
                <span style="float: right">{{ item.contactsName }}:{{ item.contactsPhone }}</span>
              </el-option>
            </el-select>
          </template>
        </c-form>
      </div>
      <div class="box-left-footer">
        <el-button type="primary" @click="doSave">提交</el-button>
        <el-button plain @click="getData">取消</el-button>
      </div>
    </div>
    <div class="box-center">
      <el-tabs v-model="activeTab" @tab-click="osg.tabClick">
        <template v-for="(ext, i) in subExts">
          <el-tab-pane :label="ext.title" :name="ext.colName" :key="i">
            <div class="box-center-tool">
              <div></div>
              <el-button type="primary" size="mini" @click="osg.subInit(true)">
                新建
              </el-button>
            </div>
            <div class="box-center-content">
              <el-table ref="table" :data="subData">
                <!-- 动态列 -->
                <c-table :fields="subFields" :options="options"></c-table>
                <el-table-column fixed="right" label="操作">
                  <template slot-scope="scope">
                    <el-button @click="osg.editExtForm(scope.row)" size="mini">编辑</el-button>
                    <el-button @click="osg.removeExtForm(scope.row)" size="mini">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
        </template>
        <el-dialog
          :title="activeExt.title"
          :visible.sync="openExtDetail"
          destroy-on-close
          @closed="osg.subInit"
        >
          <c-form
            :formData="subFormData"
            :fields="subFields"
            :options="options"
            ref="subFormData"
            :upload="upload"
            @changeForm="osg.changeForm"
          ></c-form>
          <div slot="footer">
            <el-button type="primary" @click="osg.saveExtForm(activeExt._id, subFormData)">
              确 定
            </el-button>
            <el-button @click="osg.subInit">取 消</el-button>
          </div>
        </el-dialog>
        <el-tab-pane label="动态" name="log">
          <div class="box-center-tool">
            <div>
              <el-date-picker
                v-model="log.searchDate"
                type="datetimerange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss"
                clearable
                @change="getLog"
                class="search-date"
              ></el-date-picker>
            </div>
            <div>
              <el-input
                placeholder="请输入标题/内容"
                v-model="log.searchValue"
                class="search-input"
                clearable
                @clear="getLog"
                @keyup.enter.native="getLog"
              >
                <el-button slot="append" icon="el-icon-search" @click="getLog"></el-button>
              </el-input>
            </div>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(log, i) in log.fpi.data" :key="i">
              <div class="activity-card-header">
                <span class="c-font-500">
                  <i class="el-icon-monitor c-w-30"></i>
                  {{ log.title }}
                </span>
                <span>{{ log.createTime }}</span>
              </div>
              <div class="activity-card-content">
                {{ log.content }}
              </div>
              <div class="activity-card-footer">
                <span>操作人：{{ log.updateUserName }}</span>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="笔记" name="notes">
          <div class="box-center-tool">
            <div></div>
            <el-button
              type="primary"
              size="mini"
              @click="
                vqeditor.content = ``;
                openNote = true;
              "
            >
              创建笔记
            </el-button>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(note, i) in noteData" :key="i">
              <div class="activity-card-header">
                <span>
                  <i class="el-icon-edit-outline c-w-30"></i>
                  笔记
                </span>
                <span>{{ note.createTime }}</span>
              </div>
              <div
                class="activity-card-content-node"
                v-html="note.content"
                @click="noteMdShow(note)"
                v-if="!note.openNote"
              ></div>
              <c-editor
                v-else
                class="c-m-15"
                :formData="note"
                :value="'content'"
                ref="editor"
              ></c-editor>
              <div class="activity-card-footer">
                <span>操作人：{{ note.createUserName }}</span>
              </div>
            </div>
          </div>
          <!-- markdown编辑器 -->
          <el-dialog title="笔记" :visible.sync="openNote">
            <c-editor :formData="vqeditor" :value="'content'" ref="editor"></c-editor>
            <div slot="footer">
              <el-button type="primary" @click="saveNote">确 认</el-button>
              <el-button
                @click="
                  openNote = false;
                  vqeditor.content = '';
                "
              >
                取 消
              </el-button>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="属性变更记录" name="history">
          <div
            class="box-center-content"
            v-infinite-scroll="getHistory"
            :infinite-scroll-immediate="true"
          >
            <c-modify
              :historyFpi="historyFpi"
              :fields="extFields"
              :fieldsObj="fieldsObj"
              :options="options"
              ref="modify"
            ></c-modify>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="box-right" :class="collapse ? 'box-collapse' : ''">
      <div class="box-right-header">
        <i class="el-icon-d-arrow-left" @click="collapse = false" v-if="collapse"></i>
        <i class="el-icon-d-arrow-right" @click="collapse = true" v-else></i>
      </div>
      <div class="box-right-content" v-show="!collapse">
        <el-collapse v-model="activeCollapse"></el-collapse>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'serviceAgreement',
  data() {
    window.$this = this;
    return {
      id: null,
      collapse: true,
      activeCollapse: '1',
      formData: {
        exts: {}
      },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      fieldsObj: {},
      options: {},
      // 关联子表单
      subExts: [],
      activeExt: {},
      subFields: [], //子表单字段
      subFormData: { exts: {} },
      subData: [],
      openExtDetail: false,

      rules: this.$util.rules,
      activeTab: 'log',
      // 日志
      log: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: []
      },
      historyFpi: {
        page: 1,
        rows: 0,
        data: [],
        busy: false
      },
      noteData: [],
      openNote: false,
      vqeditor: this.$util.vqeditor,
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: $this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      }
    };
  },
  mounted() {
    this.id = this.osg.param('id');
    this.osg.getFields('serviceAgreement', () => {
      this.getData();
      this.getUsers();
      this.getServiceAppointments();
      this.getContracts();
      this.osg.getSubExts('serviceAgreement');
    });
    this.getLog();
    this.getNote();
  },
  methods: {
    getData() {
      this.osg.ajax('basic/serviceAgreement/findById.do', { id: this.id }, res => {
        let row = res.data;
        row.exts = row.exts || {};
        this.formData = row;
        //获取属性修改记录
        this.getHistory();
      });
    },
    doSave() {
      if (this.osg.validate()) {
        let row = this.$util.deepCopy(this.formData);
        this.osg.ajax('basic/serviceAgreement/upsert.do', row, () => {
          this.osg.toast('保存成功！');
          this.getData();
        });
      }
    },
    getLog() {
      this.log.searchDate = this.log.searchDate || [];
      this.osg.ajax(
        'tenantLog/query.do',
        {
          sid: this.id,
          smodule: 'serviceAgreement',
          _all: '1',
          'regex:title|string#or': this.log.searchValue,
          'regex:content|string#or': this.log.searchValue,
          'gte:createTime|datetime#and': this.log.searchDate[0],
          'lte:createTime|datetime#and': this.log.searchDate[1],
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.log.fpi = res;
        },
        { noload: true }
      );
    },
    getHistory() {
      // 其他getFields查询会更新掉表单的fieldsObj
      let fieldsObj = {};
      this.extFields.map(item => {
        if (item.showList && item.showList.indexOf('6') != -1) {
          item.label = item.nameDisp;
          item.value = item.name;
          fieldsObj[item.name] = item;
        }
      });
      this.fieldsObj = fieldsObj;
      this.osg.ajax(
        'biz/changeLog/query.do',
        {
          sid: this.id,
          page: this.historyFpi.page,
          rows: (this.historyFpi.rows += 10)
        },
        res => {
          if (res.data.length > 0) {
            // 不需要展示变更的字段名
            res.data = res.data.filter(item => {
              item.modifyList = item.modifyList.filter(obj => {
                return (
                  this.fieldsObj[obj.field] && this.fieldsObj[obj.field].showList.indexOf('6') != -1
                );
              });
              return item.modifyList.length > 0;
            });
            this.historyFpi = res;
          }
        },
        { noload: true }
      );
    },
    formatField(row, column, cellValue) {
      return this.osg.codelabel('fields', cellValue);
    },
    formatFieldValue(row, column, cellValue) {
      if (this.options[row.field]) {
        return this.osg.codelabel(row.field, cellValue);
      } else {
        return cellValue;
      }
    },
    getNote() {
      this.osg.ajax(
        'note/query.do',
        {
          sid: this.id,
          smodule: 'serviceAgreement'
        },
        res => {
          this.noteData = res || [];
        },
        { noload: true }
      );
    },
    saveNote() {
      var params = {
        sid: this.id,
        smodule: 'serviceAgreement',
        content: this.vqeditor.content
      };
      this.osg.ajax('note/upsert.do', params, () => {
        this.openNote = false;
        this.getNote();
      });
    },
    noteMdShow(note) {
      note.openNote = true;
    },
    getContacts(searchVal, cb) {
      this.osg.ajax(
        'basic/contacts/query.do',
        { page: 1, rows: 20, 'regex:name|string#and': searchVal },
        res => {
          if (cb) {
            cb(res.data);
          }
        },
        {
          noload: true
        }
      );
    },
    selectContact(item) {
      this.$set(this.formData, 'contactsIds', item._id);
      this.$set(this.formData, 'contactsName', item.name);
      this.$set(this.formData, 'contactsPhone', item.phone);
    },
    getUsers(searchVal) {
      this.osg.ajax(
        'user/query.do',
        { page: 1, rows: 20, 'is:state|integer#and': 1, 'regex:name|string#and': searchVal },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.users = res.data;
          this.$forceUpdate();
        },
        {
          noload: true
        }
      );
    },
    getServiceAppointments(searchVal) {
      this.osg.ajax(
        'basic/serviceAppointment/query.do',
        {
          page: 1,
          rows: 20,
          'is:state|integer#and': 1,
          'regex:title|string#or': searchVal,
          'regex:orderNum|string#or': searchVal,
          'regex:name|string#or': searchVal,
          'regex:phone|string#or': searchVal
        },
        res => {
          res.data.map(item => {
            item.label = item.title;
            item.value = item._id;
          });
          this.options.serviceAppointments = res.data;
          this.$forceUpdate();
        },
        {
          noload: true
        }
      );
    },
    getContracts(searchVal) {
      this.osg.ajax(
        'basic/contract/query.do',
        {
          page: 1,
          rows: 20,
          'is:state|integer#and': 1,
          'regex:contractdocNum|string#or': searchVal,
          'regex:contactsName|string#or': searchVal,
          'regex:contactsPhone|string#or': searchVal
        },
        res => {
          res.data.map(item => {
            item.label = item.contractdocNum;
            item.value = item._id;
          });
          this.options.contracts = res.data;
          this.$forceUpdate();
        },
        {
          noload: true
        }
      );
    }
  }
};
</script>
